/**
 * EVERY PAGE OF THE APP IS A PAGEVIEW, FOR THE SHOP THE PAGE BELONGS TO.
 *
 * The storefront changes page without loading one. Meta's script used to count those changes
 * itself, for every pixel in the tab — so after /explore → shop A → shop B, each page of B was a
 * PageView on A's pixel too. The pixels are now marked to hear only what is sent to them by
 * name (utils/metaPixel.js), and this tells the pixel module each time the address changes and
 * when the browser restores the page from its back-forward cache — the two moments Meta's script
 * counted. Mounted once, inside the router, outside the routes.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageChange, trackPageRestored } from '../../utils/metaPixel';

export default function MetaPixelPageViews() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    trackPageChange();
  }, [pathname, search, hash]);

  useEffect(() => {
    const onShow = (event) => {
      if (event.persisted) trackPageRestored();
    };
    window.addEventListener('pageshow', onShow);
    return () => window.removeEventListener('pageshow', onShow);
  }, []);

  return null;
}
